/**
 * Masks license plate numbers in URLs to protect user privacy in analytics.
 * Looks for license-plate-like segments or parameter values anywhere in the URL.
 */

// Matches Norwegian plates:
// - Veteran: one letter + 1–6 digits. These can also have a hyphen between the letter and the digits.
// - Standard: two letters + 4-5 digits.
const LICENSE_PLATE_REGEX = /(^|[/?#&=])([A-Za-z]{1}[ -]?\d{1,6}|[A-Za-z]{2}[ -]?\d{4,5})(?=$|[/?#&=])/g;

export const maskLicensePlateNumber = (url: string): string =>
  url.replace(LICENSE_PLATE_REGEX, (_match, prefix) => `${prefix}[reg-nr]`);
